/**
 * 天地图 JS API 4.0。页面入口加载后安装 BMapGL 兼容层，业务代码无需改调用面。
 */
import { installTiandituBMapAdapter } from './tdtBMapAdapter';

export const TIANDITU_TK = '355788b9720fec131fb202ea2b495aac';
export const TIANDITU_API_URL = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_TK}`;
/** 兼容旧 import 名；实际为天地图 tk */
export const BAIDU_MAP_AK = TIANDITU_TK;

const SCRIPT_ID = 'tianditu-api-script';
let loadingPromise = null;

function isBMapGLReady() {
  return !!(window.BMapGL && window.BMapGL.Map && window.BMapGL.__tiandituAdapter);
}

function isTiandituReady() {
  return !!(window.T && window.T.Map);
}

function findExistingScript() {
  const byId = document.getElementById(SCRIPT_ID);
  if (byId) return byId;
  return Array.from(document.scripts).find((s) => {
    const src = s.src || '';
    return /api\.tianditu\.gov\.cn\/api/i.test(src);
  }) || null;
}

function injectScript() {
  let script = findExistingScript();
  if (script) {
    if (!script.id) script.id = SCRIPT_ID;
    return script;
  }
  script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.type = 'text/javascript';
  script.src = TIANDITU_API_URL;
  document.head.appendChild(script);
  return script;
}

/**
 * @param {{ timeoutMs?: number }} [opts]
 * @returns {Promise<typeof window.BMapGL>}
 */
export function ensureBMapGL(opts = {}) {
  const timeoutMs = opts.timeoutMs ?? 30000;
  if (isTiandituReady()) {
    installTiandituBMapAdapter();
  }
  if (isBMapGLReady()) {
    return Promise.resolve(window.BMapGL);
  }
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    const script = injectScript();
    const started = Date.now();

    const finishOk = () => {
      cleanup();
      loadingPromise = null;
      installTiandituBMapAdapter();
      resolve(window.BMapGL);
    };
    const finishErr = (err) => {
      cleanup();
      loadingPromise = null;
      reject(err);
    };

    let pollTimer = null;
    const cleanup = () => {
      if (pollTimer) clearInterval(pollTimer);
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };

    const onLoad = () => {
      if (isTiandituReady() && installTiandituBMapAdapter()) {
        finishOk();
      }
    };
    const onError = () => {
      finishErr(new Error('天地图脚本加载失败，请检查网络、域名白名单与 tk'));
    };

    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);

    pollTimer = setInterval(() => {
      if (isTiandituReady() && installTiandituBMapAdapter()) {
        finishOk();
        return;
      }
      if (Date.now() - started >= timeoutMs) {
        finishErr(new Error('天地图脚本加载超时'));
      }
    }, 200);
  });

  return loadingPromise;
}

export function getBaiduMapAk() {
  return TIANDITU_TK;
}

if (typeof window !== 'undefined' && isTiandituReady()) {
  installTiandituBMapAdapter();
}
